import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../../shared/base-api-template-service.model';
import {Core2Config} from '../../../shared/core2Config';
import { JobCheckListLineContainerModel } from '../../../../../../../models/aggregates/erp/delivery/job';


@Injectable({
  providedIn: 'root'
})
export class JobCheckListLineService extends BaseApiTemplateService<JobCheckListLineContainerModel> {
  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-checklist-lines';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-checklist-lines';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-checklist-lines';
    this.httpClient = http;
  }
}
